import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import i18n from '../../../../i18n';
import BzmIcon from '../../../icons/BzmIcon';
import _ from 'lodash';
import { useOuterClick } from '../../../../hooks/useOuterClick';
import { useIsMount } from '../../../../hooks/useIsMountHook';

interface AttributeListPopover {
  isChildPopoverOpen: boolean;
}

/**
 * Overlay component for rendering list of attributes in the popover. It is extracted to separate component
 * because of problem with the close.
 *
 * Example taken from: https://github.com/react-bootstrap/react-bootstrap/issues/1622
 * @param props
 * @constructor
 */
const AttributeListPopover = (props: PropsWithChildren<AttributeListPopover>) => {
  const [isShown, setIsShown] = useState(false);
  const [isChildOpen, setIsChildOpen] = useState(false);
  const isMount = useIsMount();
  const innerRef = useOuterClick(e => {
    if (!isMount && isShown && !isChildOpen) {
      setIsShown(false);
    }
  });

  useEffect(() => {
    if (!isMount && props.isChildPopoverOpen === false) {
      setIsChildOpen(false);
    }
  }, [props.isChildPopoverOpen]);

  const handleShow = () => {
    setIsShown(true);
  };

  return (
    <OverlayTrigger
      show={isShown}
      placement="bottom-end"
      overlay={
        <Popover
          style={{ minWidth: '180px' }}
          id={'list-of-attributes-' + _.uniqueId()}
          className={`popover-positioned-right`}
          title={i18n.t('servicePicker.serviceId')}
        >
          <div
            className={'p-2'}
            ref={innerRef}
            onClick={() => {
              setIsChildOpen(true);
            }}
          >
            {props.children}
          </div>
        </Popover>
      }
    >
      <Button
        className={'px-2'}
        size={'sm'}
        variant={'secondary'}
        onClick={e => {
          e.stopPropagation();
          handleShow();
        }}
      >
        <span className={'position-relative'} style={{ top: '1px' }}>
          <BzmIcon className={'position-relative'} variant={'icon-bzm-ellipsis-horizontal'} />
        </span>
      </Button>
    </OverlayTrigger>
  );
};

export default AttributeListPopover;
